import React, { memo } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import './DataBlock.scss';
import { getClasses } from '@utils';

interface DataCardRowProps {
	children?: ReactNode;
	hidden?: Boolean;
}

export const DataBlock: FunctionComponent<DataCardRowProps> = memo(({ children, hidden }) => (
	<section
		className={getClasses({
			'data-block': true,
			'data-hidden': Boolean(hidden),
		})}
	>
		{children}
	</section>
));
